// assets
import {
    IconKey,
    IconNews,
    IconCurrencyEthereum,
    IconCurrencyBitcoin,
} from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconNews,
    IconCurrencyEthereum,
    IconCurrencyBitcoin,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages = {
    id: 'pages',
    title: 'Pages',
    type: 'group',
    children: [
       
        {
            id: 'transactions',
            title: 'Transactions',
            type: 'collapse',
            icon: icons.IconCurrencyBitcoin,

            children: [
                {
                    id: 'deposit',
                    title: 'Deposit',
                    type: 'item',
                    url: '/pages/transaction/deposit',
                },
                {
                    id: 'withdraw',
                    title: 'Withdraw',
                    type: 'item',
                    url: '/pages/transaction/withdraw',
                },
                {
                    id: 'history',
                    title: 'Transaction History ',
                    type: 'item',
                    url: '/pages/transaction/history',
                },
            ],
        },

        {
            id: 'news',
            title: 'Crypto News',
            type: 'item',
            url: '/news-page',
            icon: icons.IconNews,
            breadcrumbs: false,
        },

        {
            id: 'cyptos',
            title: 'All Cryptocurrrencies',
            type: 'item',
            url: '/all-cryptocurrencies',
            icon: icons.IconCurrencyEthereum,
            breadcrumbs: false,
        },
    ],
};

export default pages;
